import { render, staticRenderFns } from "./PopupPWAInstructions.vue?vue&type=template&id=6130d850"
import script from "./PopupPWAInstructions.vue?vue&type=script&lang=js"
export * from "./PopupPWAInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports